export default "/images/f42722fcff1ae7fed3d10b614a57768b.avif";